export const capitalize = (str = '') => `${str[0].toUpperCase()}${str.slice(1)}`;